import type {EditionApiModel} from '../../../api/program/edition';
import type {Nullable} from '../../utility-types';

import {isDefined} from '../../typecheck';

type TargetProgram = Nullable<{
  editions?: null | Nullable<EditionApiModel>[];
}>;

export const isProgramGroup = (program: TargetProgram) => {
  if (!isDefined(program)) {
    return false;
  }

  const lastEdition = program.editions?.slice().pop();

  return Boolean(lastEdition && lastEdition.group_size > 1);
};
